import { InlineWidget, useCalendlyEventListener } from 'react-calendly';

type BookTimeProps = {
  onScheduled: () => void;
};

// TODO: Move to constants
const TANDRA_CALENDLY_URL = 'https://calendly.com/tandra-le/30min';

const BookTime = ({ onScheduled: onEventScheduled }: BookTimeProps) => {
  useCalendlyEventListener({ onEventScheduled });

  return (
    <div className="p-4 flex flex-col w-[46rem]">
      <div className="flex flex-col">
        <h2 className="font-bold text-2xl">Awesome. Excited to get started.</h2>
        <div className="flex flex-wrap items-center text-xl text-huddleBlack">
          <span>Grab time with me, your Huddle Partner</span>
          <img
            className="mx-1 rounded-full h-8 w-8 border-2 border-orange-300"
            src="/images/tandra.jpeg"
            alt="Image of Tandra"
          />
          <span>Tandra.</span>
        </div>
        <InlineWidget
          url={TANDRA_CALENDLY_URL}
          pageSettings={{ hideEventTypeDetails: true, hideLandingPageDetails: true }}
        />
      </div>
    </div>
  );
};

export default BookTime;
